// extracted by mini-css-extract-plugin
module.exports = {"ribbon":"INg0tB","mobile":"XpZVAx","on-image":"FbHYze","onImage":"FbHYze","categoryPage":"WR5J5H","product-info":"IPqs5F","productInfo":"IPqs5F","rectangle":"oOOCOE"};